import React from 'react';

import adminApiClient from 'api/adminApiClient';
import backofficeApiClient, {
  ResourceDownloadResponse,
} from 'api/backofficeApiClient';
import FormikFileUpload from 'components/formik/FormikFileUpload';
import { generateUploadFileList, getFileUploadMessages } from 'utils/fileUtils';
import BaseDraggerContent from 'components/wrappers/BaseFileUpload/BaseDraggerContent';
import UploadList from 'components/wrappers/BaseFileUpload/UploadList';
import FormItem from 'components/formik/FormItem';

const FILE_TYPES = ['DOC', 'DOCX', 'PDF', 'RTF'];
const fileUploadMessages = getFileUploadMessages({
  fileTypes: FILE_TYPES,
});

type Props = {
  isAdmin?: boolean;
  w8w9File?: ResourceDownloadResponse;
};

export default React.memo((props: Props) => {
  const { isAdmin, w8w9File } = props;

  const fileList = w8w9File ? generateUploadFileList(w8w9File) : [];

  return (
    <FormItem name="w8w9FilePath" showValidateError={false}>
      <FormikFileUpload
        name="w8w9FilePath"
        isDraggable
        defaultFileList={fileList}
        acceptedFileSize={10}
        acceptedFileFormat={[
          '.doc',
          '.docx',
          '.pdf',
          '.rtf',
          'application/msword',
          'application/pdf',
          'application/rtf',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ]}
        getUploadList={UploadList}
        messages={fileUploadMessages}
        uploadLinkFunction={
          isAdmin
            ? adminApiClient.getEntityInfoFileUploadLink.bind(adminApiClient)
            : backofficeApiClient.getEntityInfoFileUploadLink.bind(
                backofficeApiClient,
              )
        }
      >
        {() => <BaseDraggerContent fileTypes={FILE_TYPES} />}
      </FormikFileUpload>
    </FormItem>
  );
});
